import React from 'react'
import { Card, Col, FormGroup, Row, Spinner } from 'reactstrap'
import bgImage from "../../assets/images/bgImage1.jpg"
import { useForm } from 'react-hook-form'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import usePasswordConfirm from './usePasswordConfirm'

const PasswordConfirmPage = () => {

  const navigate = useNavigate();

  // get uid and token from the url
  const {uid,token} = useParams();
  // custom hook to confirm new password
  const{isPending,isSuccess,changePassword} = usePasswordConfirm();

  const{register,handleSubmit,formState:{errors},watch} = useForm({
    defaultValues:{
      password:"",
      password2:""
    },
    criteriaMode:"all",
    mode:"onChange"
  })

  const password = watch("password")

  const onSubmit=(data)=>{
    console.log("new pass",data)

    const payload = {
      password: data.password,
      password2: data.password2,
      user_id: uid,
      token: token
    }
    console.log("payload",payload)
    changePassword(payload)
  }

  return (
    <div className='account-pages'>
      <div
        className='accountbg'
        style={{
          background: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Card
          style={{
            height: "400px",
            width: "400px",
            display: "flex",
            flexDirection: "column",
            borderRadius: "15px",
            padding: "20px",
            borderColor: "white",
            borderWidth: "1.5px",
            backgroundColor: "white",
            boxShadow: "0 0 15px rgba(0, 0, 0, 0.2)",
            backdropFilter:"blur(10px)",
            opacity:"1"
          }}
        >
          <Row>
            <Col
              style={{
              display: "flex",
              flexDirection:"column",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "20px",
            }}
            >
              <h2 style={{color:"#00ADF0"}}>Change Password</h2>
            </Col>
          </Row>

          <Row>
            <Col>
              <form className='p-2' onSubmit={handleSubmit(onSubmit)}>
                <div className='mb-3'>
                  <FormGroup>
                    <label htmlFor='password' className='form-label'>New Password</label>
                    <input
                      type='password'
                      className='form-control border-primary-subtle'
                      id='password'
                      name='password'
                      placeholder='New Password'
                      {...register("password",{required:"New Password required",
                        minLength:{value:6,message:"Password must be at least 6 characters long"},
                        maxLength:{value:12, message:"Password must not exceed 12 characters"},
                        pattern:{value:/^(?!.*\s)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]{6,12}$/,
                                  message:"Password must be 6–12 characters long, include at least one uppercase letter, one lowercase letter, one number, one special character, and contain no spaces."}

                      })}
                    />
                    {errors.password && <span className="text-danger">{errors.password.message}</span>}
                  </FormGroup>

                  <FormGroup>
                    <label htmlFor='password2' className='form-label'>Confirm Password</label>
                    <input
                      type='password'
                      className='form-control border-primary-subtle'
                      id='password2'
                      name='password2'
                      placeholder='Confirm Password'
                      {...register("password2",{required:"Confirm Password required",
                        minLength:{value:6,message:"Password must be at least 6 characters long"},
                        maxLength:{value:12, message:"Password must not exceed 12 characters"},
                        pattern:{value:/^(?!.*\s)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]{6,12}$/,
                                  message:"Password must be 6–12 characters long, include at least one uppercase letter, one lowercase letter, one number, one special character, and contain no spaces."},
                        validate:(value) => value === password || "Password do not match"

                      })}
                    />
                    {errors.password2 && <span className="text-danger">{errors.password2.message}</span>}
                  </FormGroup>
                </div>
                <div className='mb-3'>
                      <button type='submit' className="btn w-100 mt-2" style={{backgroundColor:"#00ADF0", color:"white"}}
                        disabled={isPending}
                      >
                        {isPending ? <Spinner size='sm'/> :'Submit'}
                      </button>
                </div>
                <div className="text-center mt-1 pt-2 ">
                  © {new Date().getFullYear()} TrueFocus Automation. All rights reserved.
                </div>
              </form>
            </Col>
          </Row>
        </Card>
      </div>
    </div>
  )
}

export default PasswordConfirmPage